// Text-font stylesheets load deferred (media="print" in index.html) so they
// don't block first paint; CSP forbids inline onload handlers, so the flip
// to media="all" happens here, the moment the bundle runs.
document.querySelectorAll('link[data-defer-font]').forEach((l) => { l.media = 'all'; });

import "./instrument"; // Sentry — MUST be first import

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// Initialize i18n
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
